import axios from "../general/HttpClient";

export interface BreakdownItem {
    key: string;
    label: string;
    count: number;
}

export interface GroupOptionItem {
    id: string;
    name: string;
    type: string;
    groupCustomTypeID: string | null;
    customTypeName: string | null;
    memberCount: number;
}

export interface OrganizationMembershipStats {
    totalUsers: number;
    activeUsers: number;
    inactiveUsers: number;
    totalMemberships: number;
    multiMembershipUsers: number;
    crossOrgUsers: number;
    crossOrgOrganizationCount: number;
    typeBreakdown: BreakdownItem[];
    overlapBreakdown: BreakdownItem[];
}

export interface GroupMembershipStats {
    totalMembers: number;
    totalMemberships: number;
    activeMembers: number;
    inactiveMembers: number;
    externalMembers: number;
    multiGroupUsers: number;
    crossOrgUsers: number;
    membershipTypeBreakdown: BreakdownItem[];
    overlapBreakdown: BreakdownItem[];
    groupTypeBreakdown: BreakdownItem[];
    groupOptions: GroupOptionItem[];
}

export interface OrganizationStats {
    organization: OrganizationMembershipStats;
    groups: GroupMembershipStats;
}

export interface StatsUserMembership {
    label: string;
    detail: string;
    enabled: boolean | null;
}

export interface StatsUser {
    id: string;
    name: string;
    email: string;
    memberships: StatsUserMembership[];
}

export interface StatsUserListResponse {
    total: number;
    page: number;
    pageSize: number;
    items: StatsUser[];
}

export function GetStats(): Promise<OrganizationStats> {
    return axios.get("/api/organizations/stats").then((response) => response.data);
}

export function GetStatsUsers(section: string, filters: string[], page: number, pageSize: number): Promise<StatsUserListResponse> {
    return axios
        .get("/api/organizations/stats/users", {
            params: { section, filters: filters.join(","), page, pageSize },
        })
        .then((response) => response.data);
}
